/* eslint-disable vue/max-len */
/* eslint-disable new-parens */
import { ListFactory, isValidArray } from '@razlet/utils';
import Pagination from '../pagination';
import TreeFactory from './factories/tree';
import EntityFactory from './factories/entity';

export default class ListWthPagination {
  pagination = null;
  list = [];

  Entity = null;

  listProperty = 'list';

  constructor (data, Entity, type = 'list', listProperty = 'list') {
    this.listProperty = listProperty;
    this.Entity = Entity;

    this.type = type;

    if (this.isList) this.fillList(data);
    else if (this.isTree) this.fillTree(data);
    this.fillPagination(data);
  }

  get isFilled () {
    if (this.isTree) return isValidArray(this.list);
    return this.pagination && this.pagination.total !== null;
  }

  get ids () {
    return this.list.map(item => item.id);
  }

  get isList () {
    return this.type === 'list';
  }

  get isTree () {
    return this.type === 'tree';
  }

  fillList (data) {
    if (data.list) this.list = ListFactory.createRows(this.Entity, data.list);
  }

  fillTree (data) {
    if (data.list) this.list = TreeFactory.createTreeList(this.Entity, data.list);
  }

  fillPagination (data) {
    if (data.pagination) this.pagination = EntityFactory.create(Pagination, data.pagination);
  }

  clean () {
    this.list = [];
  }

  prependItem (entityData, rowData) {
    if (this.list) {
      if (this.isList) this.list.unshift(EntityFactory.createRow(this.Entity, entityData, rowData));
      else if (this.isTree) this.list.unshift(TreeFactory.createTree(this.Entity, entityData, rowData));
    }
  }

  addItem (entityData, rowData) {
    if (this.list) {
      if (this.isList) this.list.push(EntityFactory.createRow(this.Entity, entityData, rowData));
      else if (this.isTree) this.list.push(TreeFactory.createTree(this.Entity, entityData, rowData));
    }
  }

  addItems (data) {
    if (this.list) {
      if (this.isList) this.list.push(...ListFactory.createRows(this.Entity, data.list));
      else if (this.isTree) this.list.push(...TreeFactory.createTreeList(this.Entity, data.list));
    }
    this.fillPagination(data);
  }

  removeItem (id) {
    this.list = this.list.filter(item => item.id !== id);
    if (this.pagination) this.pagination.total -= 1;
  }

  replaceItem (id, entityData, rowData = {}) {
    const index = this.list.findIndex(item => item.id === id);
    let prevMountKey = this.list[index].mountKey;

    if (this.isList) {
      this.list[index] = EntityFactory.createRow(this.Entity, entityData, {
        mountKey: prevMountKey += 1,
        ...rowData,
      });
    } else if (this.isTree) {
      this.list[index] = TreeFactory.createTree(this.Entity, entityData, {
        mountKey: prevMountKey += 1,
        ...rowData,
      });
    }

    return index;
  }
}
